const translations = {
    createNewAam: 'Create New AAM'
};

export default translations;
